import service from "./service"
import apiUtil from './apiUtil'
import questionnaire from './questionnaire'
import questionnaire2 from './questionnaire2'
import questionnaire3 from './questionnaire3'
import activity from './activity'
import pc from './pc'
import wxAcivity from './wxAcivity'


let params = _.extend(service, questionnaire, activity, questionnaire2, questionnaire3,pc,wxAcivity)

const generateApiMap = apiUtil.generateApiMap({ ...params })
export default {
  ...generateApiMap // 取出所有可遍历属性赋值在新的对象上
}



// WEBPACK FOOTER //
// ./src/api/index.js